import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/Button';
import SchemeSelector from '@/components/SchemeSelector';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiMenu, FiLogOut } = FiIcons;

const pageTitles = {
  '/': { title: 'Dashboard', subtitle: 'Scheme analytics & insights' },
  '/upload': { title: 'Upload Users', subtitle: 'Import user data via CSV' },
  '/users': { title: 'All Users', subtitle: 'Manage and export scheme users' },
  '/schemes': { title: 'All Schemes', subtitle: 'Campaign management' },
  '/logs': { title: 'API Logs', subtitle: 'Monitor system activity' },
};

const Header = ({ toggleSidebar }) => {
  const { logout } = useAuth();
  const location = useLocation();
  const page = pageTitles[location.pathname] || pageTitles['/'];

  // Hide SchemeSelector for Global Pages as requested
  const isGlobalPage = ['/schemes', '/logs'].includes(location.pathname);

  return (
    <header className="flex h-16 items-center justify-between bg-white border-b border-surface-200 px-4 md:px-6 sticky top-0 z-30 gap-3">
      <div className="flex items-center space-x-4 min-w-0">
        <button onClick={toggleSidebar} className="md:hidden p-2 rounded-xl text-surface-500 hover:bg-surface-100 transition-colors shrink-0">
          <SafeIcon icon={FiMenu} className="w-5 h-5" />
        </button>
        <div className="min-w-0">
          <h1 className="text-lg font-bold text-surface-800 leading-none truncate">{page.title}</h1>
          <p className="text-[10px] text-surface-400 mt-1 hidden sm:block font-medium uppercase tracking-wider">{page.subtitle}</p>
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0">
        {!isGlobalPage && <SchemeSelector />}
        
        <div className="flex items-center space-x-2 pl-3 border-l border-surface-200">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center text-white text-xs font-bold shadow-sm">A</div>
        </div>
        <Button variant="ghost" size="sm" onClick={logout} className="text-surface-500 hover:text-red-600 hover:bg-red-50">
          <SafeIcon icon={FiLogOut} className="w-4 h-4" />
          <span className="hidden sm:inline ml-2 text-xs font-bold">Logout</span>
        </Button>
      </div>
    </header>
  );
};

export default Header;